<template>
  <div>
    <span class="pointer" @click="showChatDialog()">
      <slot></slot>
    </span>
    <div class="chat-container">
      <div class="chat-container-tab" v-if="currentPage === 'detail'">
        <i @click="goBackList()" class="el-icon-arrow-left"></i>
        <img class="avatar" v-if="session && session.user && session.user.avatar" :src="session.user.avatar.indexOf('http://pic.joyorders.com')>-1?session.user.avatar:'http://pic.joyorders.com' + session.user.avatar">
        <img class="avatar" v-if="session && session.user && !session.user.avatar" src="../../assets/images/avatar@2x.png" />

        <span v-if="session && session.user">{{session.user.nick}}</span>
      </div>
      <div class="chat-container-tab sessions" v-else>
          <img class="avatar" v-if="nim && nim.user && nim.user.avatar" :src="nim.user.avatar.indexOf('http://pic.joyorders.com')>-1?nim.user.avatar:'http://pic.joyorders.com' + nim.user.avatar">
          <img class="avatar" v-if="nim && nim.user && !nim.user.avatar" src="../../assets/images/avatar@2x.png" />
          <span v-if="nim && nim.user">{{nim.user.nick}}</span>
      </div>
      <div class="chat-container-body">
        <ChatSessions v-on:selectSession="selectSession" v-if="nim.sessions && currentPage === 'list'"></ChatSessions>
        <ChatDetail v-on:setSession="setSession" :toAccountId="nim.toAccountId" :session="session" v-if="nim.addFriend &&currentPage === 'detail'"></ChatDetail>
      </div>
    </div>
  </div>
</template>

<script>
import ChatSessions from './ChatSessions'
import ChatDetail from './ChatDetail'

export default {
  name: 'Chat',
  props: ['isP2p'],
  components: {
    ChatSessions,
    ChatDetail
  },
  computed: {
    nim () {
      return this.$store.state.nim
    }
  },
  data () {
    return {
      currentPage: 'list',
      session: null
    }
  },
  created () {
    this.currentPage = this.nim.pageType || this.currentPage
    console.log('nimnimnimnimnim', this.nim)
  },
  methods: {
    goBackList () {
      this.$store.commit('updateNim', {
        pageType: 'list',
        toAccountId: null,
        showChat: true
      })
    },
    selectSession (session) {
      console.log('sessionsessionsessionsession', session)
      this.session = session
      this.$store.commit('updateNim', {
        pageType: 'detail',
        toAccountId: null,
        showChat: true
      })
    },
    setSession (session) {
      this.session = session
    }
  },
  watch: {
    'nim.pageType' (value) {
      this.currentPage = this.nim.pageType || this.currentPage
    },
    'nim.toAccountId' (value) {
      if (!value) {
        return
      }
      this.session = null
      this.$store.commit('updateNim', {
        pageType: 'list',
        toAccountId: value,
        showChat: true
      })
      setTimeout(() => {
        this.$store.commit('updateNim', {
          pageType: 'detail',
          toAccountId: value,
          showChat: true
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.chat-container {
  border-radius: 0 0 5px 5px;
  box-shadow:0px 2px 4px 0px rgba(153,153,153,0.5);
  background-color: #fff;

  .chat-container-tab {
    background-color: #2C2E31;
    height: 46px;
    padding-left: 5px;

    .avatar{
      border-radius: 100%;
    }

    & > * {
      float: left;
    }

    i {
      color: #fff;
      font-size: 30px;
      line-height: 46px;
      font-weight: 1000;
      cursor: pointer;
    }

    img {
      height: 30px;
      width: 30px;
      border-radius: 100%;
      margin-top: 8px;
      margin-left: 5px;
    }

    &.sessions {
      height: 110px;

      img {
        height: 60px;
        width: 60px;
        margin-top: 25px;
        margin-left: 25px;
      }

      span {
        margin-top: 30px;
        margin-left: 20px;
      }
    }

    span {
      color: #fff;
      line-height: 46px;
      margin-left: 15px;
    }
  }

  .chat-container-body {
    height: 500px;
    overflow: auto;
  }
  @media (max-width: 768px) {
    .chat-container-body {
      height: calc(100vh - 136px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chat/ChatContainer.vue